import {FEATURE_NAMES} from '../../growthbook/constants';
import {publishEvent} from '../../services/analytics/pub-sub';
import {ANALYTIC_EVENTS} from '../../services/analytics/pub-sub/constants';
import templater from '../templater';

const BOTTOM_TYPE = 'bottom';
const ASIDE_TYPE = 'aside';
const DEFAULT_LIMIT = 10;
const SPORT_INDEX = 'sport';
const FAMILY_INDEX = 'family';
const FINANE_INDEX = 'finance';
const FOOD_INDEX = 'food';
const FINANCE_INDEX_IN_URL = 'nurfin';
const CATEGORY_INDEXES = {
  food: {
    www: FOOD_INDEX,
    kaz: 'kaz'
  },
  sport: {
    www: SPORT_INDEX,
    kaz: 'sport_kaz'
  },
  finance: {
    www: FINANE_INDEX,
    kaz: 'kaz'
  },
  family: {
    www: FAMILY_INDEX,
    kaz: 'kaz'
  },
  other: {
    www: 'ru',
    kaz: 'kaz'
  }
};
const MAIN_PAGE_INDEXES = {
  www: 'main_ru',
  kaz: 'main_kaz'
};
const getPageIndex = () => {
  const currentLanguage = window.Site?.targeting.section;
  const urlParts = window.location.pathname.split('/').filter(Boolean);

  if (urlParts.length === 0) {
    return MAIN_PAGE_INDEXES[currentLanguage];
  }

  switch (urlParts[0]) {
    case SPORT_INDEX:
      return CATEGORY_INDEXES.sport[currentLanguage];
    case FOOD_INDEX:
      return CATEGORY_INDEXES.food[currentLanguage];
    case FAMILY_INDEX:
      return CATEGORY_INDEXES.family[currentLanguage];
    case FINANCE_INDEX_IN_URL:
      return CATEGORY_INDEXES.finance[currentLanguage];
    default:
      return CATEGORY_INDEXES.other[currentLanguage];
  }
};

const sendEventToRecommend = (discoveryApi, userId) => (articleId, eventType) => {
  if (!discoveryApi || !userId || !articleId) {
    return false;
  }
  publishEvent(ANALYTIC_EVENTS.RECOMMENDATION, {
    articleId: Number(articleId),
    eventType
  });

  return fetch(`${discoveryApi}${eventType}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({userId, postId: articleId.toString()})
  })
    .catch(console.error);
};

const appendRecommend = (htmlList, template, $appendContainer) => {
  if (htmlList && htmlList.length > 0 && $appendContainer) {
    $appendContainer.innerHTML = templater(template.innerHTML, {list: htmlList.join('')});
  }
};

const createTemplate = (list, $container, $template) => {
  if (!$template) {
    return;
  }

  const $itemTemplate = document.getElementById('js-template-recommended-item');

  if (!$itemTemplate) {
    console.error('not available item template');
    return;
  }

  const htmlList = list.map(item => templater($itemTemplate.innerHTML, item));

  appendRecommend(htmlList, $template, $container);
};

const showRecommend = ({
  recommendedApiUrl,
  userId,
  articleId,
  callback,
  type,
  recommendUrlSuffix = '',
  sendEventPage,
  categoryIds,
  limit,
  chunkResultList
}) => {
  if (!recommendedApiUrl || !userId || !type) {
    return;
  }

  const $container = document.querySelector('.js-block-recommended');

  if (!$container && !callback) {
    return;
  }

  const queryParams = [
    `previousPage=${document.referrer}`,
    `&userId=${encodeURI(userId)}`,
    articleId ? `&articleId=${articleId}` : `&sectionId=${window.Site.targeting.sectionId}&lifespan=7`,
    categoryIds ? `&mode=eg&categoryIds=${categoryIds?.join(',')}` : '',
    `&limit=${limit || DEFAULT_LIMIT}`,
    `&index=${getPageIndex()}`,
    recommendUrlSuffix
  ].join('');

  fetch(`${recommendedApiUrl}recommendations?${queryParams}`)
    .then(response => (response.ok
      ? response.json() : Promise.reject(`Recommendation system: API response status – ${response.status}`)))
    .then(result => {
      if (!result || !result.length) {
        console.error('Recommendation system: there\'s no results from API');
        return;
      }

      const [firstList, secondList] = chunkResultList?.(result) || [[], []];
      const $template = document.getElementById('js-template-recommended-container');

      callback?.(firstList, sendEventPage);
      createTemplate(secondList, $container, $template);
    })
    .catch(console.error);
};

export const initRecommend = ({userId, ...props}) => {
  const discoveryApi = window.Site?.discoveryApi;
  const recommendedApiUrl = window.Site?.webApiDomain;
  const isCategoryRecommendationsEnabled = window.Site?.isCategoryRecommendationsEnabled;
  const recommendUrlSuffix = window.growthBook?.getFeatureValue(FEATURE_NAMES.RECOMMENDATION_URL_SUFFIX);
  const $article = document.querySelector('.js-article');
  const {id: articleId, isOnlyLinkEnabled} = $article?.dataset || {};

  if (discoveryApi && userId && recommendedApiUrl) {
    const type = window.Site.targeting.platform === 'smartphone' ? BOTTOM_TYPE : ASIDE_TYPE;
    const sendEventPage = isOnlyLinkEnabled
      ? () => {}
      : sendEventToRecommend(discoveryApi, userId);

    sendEventPage(articleId, 'visit');
    publishEvent(ANALYTIC_EVENTS.VISIT, {articleId});

    showRecommend({
      recommendUrlSuffix,
      categoryIds: isCategoryRecommendationsEnabled
        ? window.Site?.childCategories : null,
      recommendedApiUrl,
      articleId,
      userId,
      type,
      sendEventPage,
      ...props
    });
  }
};
